import connectToStores from 'alt-utils/lib/connectToStores'
import { AppLinkStore } from 'stores'
import { AppLinkActions } from 'actions'
import { Loading, Nav, SimpleDialog, HelpEmail } from 'components'
import Helmet from 'react-helmet'

@connectToStores
export default class AppLinkContainer extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
  }

  static getStores() {
    return [AppLinkStore]
  }

  static getPropsFromStores() {
    return AppLinkStore.getState()
  }

  componentWillMount() {
    const { id, shop } = this.props.location.query
    const resource = this.props.location.query.r
    const checkTypeKey = this.props.location.query.k

    AppLinkActions.getLink.defer(id, resource, (link) => {
      if (checkTypeKey === 'serppreview')
        this.context.router.replace(`/serppreview?u=${link.url}`)
      else
        this.context.router.replace(`/checks/${checkTypeKey}?ah=${link.url}`)
    })
  }

  render() {
    if (this.props.errored === true) {
      return (
        <div className="app-link-container">
          <Helmet title='Plug in SEO - Checking Shopify app link errored' />
          <Nav toolbarTitleText='Error: Couldn&apos;t fetch' />
          <SimpleDialog
            title='Error: Couldn&apos;t fetch'
            message={<div>Go back to your Shopify admin and try again. If the problem persists, email <HelpEmail /></div>}
            open={true}
            modal={true}
            actionButtonLabel=''
          />
        </div>
      )
    } else {
      return (
        <div className="app-link-container">
          <Helmet title='Plug in SEO - Checking...' />
          <Nav toolbarTitleText='Checking...' />
          <Loading />
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./app/containers/AppLinkContainer.js